<template>
  <div class="app" :class="{ 'admin': isAdminRoute }">
    <!-- 管理页面不显示 Header 和 Footer -->
    <template v-if="!isAdminRoute">
      <Header></Header>
      <transition name="route-fade" mode="out-in">
        <main class="container">
          <RouterView />
        </main>
      </transition>
      <Footer></Footer>
    </template>
    <!-- 管理页面全屏显示 -->
    <template v-else>
      <RouterView />
    </template>
  </div>
</template>

<script setup lang="ts">
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

const route = useRoute()
const isAdminRoute = computed(() => route.path.startsWith('/w-admin'))

// 路由切换时自动回到顶部
watch(
  () => route.fullPath,
  () => {
    // 延迟一点点，保证页面DOM已渲染完成
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10)
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
.admin {
  height: 100%;
}
// 宽度铺满全屏，去掉最大宽度和居中
.container {
  flex: 1;
  width: 100%;
}

/* 路由切换淡入动画 */
.route-fade-enter-active,
.route-fade-leave-active {
  transition: opacity 0.3s ease;
}
.route-fade-enter-from {
  opacity: 0;
}
.route-fade-leave-to {
  opacity: 0;
}
</style>